import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/views/Layout.vue'
import { useUserStore } from '@/stores/user'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/auth/Login.vue'),
      meta: { title: '登入', requiresAuth: false }
    },
    {
      path: '/',
      name: 'Layout',
      component: Layout,
      redirect: '/dashboard',
      meta: { requiresAuth: true },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard.vue'),
          meta: { title: 'route.dashboard', icon: 'HomeFilled' }
        },
        // {
        //   path: 'system/template',
        //   name: 'TemplateManagement',
        //   component: () => import('@/views/system/TemplateManagement.vue'),
        //   meta: { title: 'route.template_management', icon: 'Picture' }
        // },
        // {
        //   path: 'content/carousel',
        //   name: 'CarouselList',
        //   component: () => import('@/views/content/CarouselList.vue'),
        //   meta: { title: 'route.carousel_list', icon: 'PictureFilled' }
        // },
        {
          path: 'content/category',
          name: 'CategorySetting',
          component: () => import('@/views/content/CategorySetting.vue'),
          meta: { title: 'route.category_setting', icon: 'Menu', permission: [1, 2, 99] }
        },
        {
          path: 'system/dict',
          name: 'DictManagement',
          component: () => import('@/views/system/PizuDict.vue'),
          meta: { title: 'route.dict_management', icon: 'Notebook', permission: [1, 2, 99]  }
        },
        {
          path: 'content/news',
          name: 'NewsRoot',
          redirect: '/content/news/list',
          meta: { title: 'route.news_list', icon: 'Reading', permission: [2, 99]  },
          children: [
            {
              path: 'list',
              name: 'NewsList',
              component: () => import('@/views/content/NewsList.vue'),
              meta: { title: 'route.news_list', icon: 'List', hidden: true, permission: [2, 99]  }
            },
            {
              path: 'edit/:master_id?',
              name: 'NewsEdit',
              component: () => import('@/views/content/NewsEdit.vue'),
              meta: { title: 'route.news_edit', hidden: true, permission: [2, 99]  }
            }
          ]
        },
        {
          path: 'content/pr',
          name: 'PRRoot',
          redirect: '/content/pr/list',
          meta: { title: 'route.pr_list', icon: 'Reading', permission: [4]  },
          children: [
            {
              path: 'list',
              name: 'PRList',
              component: () => import('@/views/content/PRNewsList.vue'),
              meta: { title: 'route.pr_list', icon: 'List', hidden: true, permission: [4]  }
            },
            {
              path: 'edit/:master_id?',
              name: 'PREdit',
              component: () => import('@/views/content/PRNewsEdit.vue'),
              meta: { title: 'route.pr_edit', hidden: true, permission: [4]  }
            }
          ]
        },
        {
          path: 'content/notice',
          name: 'NoticeRoot',
          redirect: '/content/notice/list',
          meta: { title: 'route.notice_list', icon: 'Bell', permission: [1, 99]  },
          children: [
            {
              path: 'list',
              name: 'NoticeList',
              component: () => import('@/views/content/NoticeList.vue'),
              meta: { title: 'route.notice_list', icon: 'List', hidden: true, permission: [1, 99]  }
            },
            {
              path: 'edit/:master_id?',
              name: 'NoticeEdit',
              component: () => import('@/views/content/NoticeEdit.vue'),
              meta: { title: 'route.notice_edit', hidden: true, permission: [1, 99]  }
            }
          ]
        },
        {
          path: 'content/single_page',
          name: 'SinglePageRoot',
          redirect: '/content/single_page/list',
          meta: { title: 'route.single_page_list', icon: 'Document', permission: [1, 2, 99]  },
          children: [
            {
              path: 'list',
              name: 'SinglePageList',
              component: () => import('@/views/content/SinglePageList.vue'),
              meta: { title: 'route.single_page_list', icon: 'List', hidden: true, permission: [1, 2, 99]  }
            },
            {
              path: 'edit/:id?',
              name: 'SinglePageEdit',
              component: () => import('@/views/content/SinglePageEdit.vue'),
              meta: { title: 'route.single_page_edit', hidden: true, permission: [1, 2, 99]  }
            }
          ]
        },
        // {
        //   path: 'system/footer_menu',
        //   name: 'FooterMenu',
        //   component: () => import('@/views/system/FooterMenu.vue'),
        //   meta: { title: 'route.footer_menu', icon: 'Bottom' }
        // },
        {
          path: 'recruitment',
          name: 'Recruitment',
          redirect: '/recruitment/list',
          meta: { title: 'route.recruitment_management', icon: 'User', permission: [3, 99]  },
          children: [
            {
              path: 'intro',
              name: 'RecruitmentIntro',
              component: () => import('@/views/system/RecruitmentIntro.vue'),
              meta: { title: 'route.recruitment_intro', icon: 'List', hidden: true, permission: [3, 99]  }
            },
            {
              path: 'list',
              name: 'RecruitmentList',
              component: () => import('@/views/system/RecruitmentList.vue'),
              meta: { title: 'route.recruitment_list', icon: 'List', hidden: true, permission: [3, 99]  }
            },
            {
              path: 'edit/:id?',
              name: 'RecruitmentEdit',
              component: () => import('@/views/system/RecruitmentEdit.vue'),
              meta: { title: 'route.recruitment_edit', hidden: true, permission: [3, 99]  }
            }
          ]
        },
        {
          path: 'user/change_password',
          name: 'ChangePassword',
          component: () => import('@/views/system/ChangePassword.vue'),
          meta: { title: 'route.user_management', icon: 'User', hidden: true, permission: [1,2,3 , 99]  }
        },
      ]
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFound.vue'),
      meta: { title: '404 Not Found', requiresAuth: false }
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  if (to.meta.requiresAuth && !userStore.token) {
    next({ name: 'Login' })
  } else if (to.name === 'Login' && userStore.token) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router
